<template>
  <AppSection
    id="profile"
    :title="$t($getConst.pages.settings.profile)"
    type="page"
    :is-section-loading="isUpdating"
  >
    <AppSection
      id="personal-details"
      :title="$t($getConst.pages.personalDetails.personalDetails)"
      class="mb-3"
    >
      <b-row>
        <b-col md="6">
          <b-form-group id="firstname" :label="$t($getConst.pages.personalDetails.first_name)" label-for="firstname-input">
            <b-form-input
              id="firstname-input"
              disabled
              :value="userDetails.firstName"
              class="text-capitalize"
              size="lg"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="lastName" :label="$t($getConst.pages.personalDetails.last_name)" label-for="lastName-input">
            <b-form-input
              id="lastName-input"
              disabled
              :value="userDetails.lastName"
              class="text-capitalize"
              size="lg"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group id="language" :label="$t(this.$getConst.pages.personalDetails.preferredLanguage)" label-for="language-input">
            <multiselect
              v-model="$v.form.language.$model"
              :class="{ 'is-invalid': $v.form.language.$error }"
              track-by="id"
              label="name"
              :disabled="$store.getters['auth/isLoggedAs'] || isUpdating"
              :placeholder="$t(this.$getConst.pages.form.select_option)"
              :allow-empty="false"
              :options="languages"
              @select="changeLanguage"
            >
              <template slot="singleLabel" slot-scope="props">
                <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
                {{$t(props.option.name) | capitalize}}
              </template>
              <template slot="option" slot-scope="props">
                <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
                {{$t(props.option.name.toLowerCase()) | capitalize}}
              </template>
              <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
            </multiselect>
            <AppFormFeedback :errors="$v.form.language"/>
          </b-form-group>
        </b-col>
      </b-row>
    </AppSection>

    <PersonalContacts @update="(arg) => this.isUpdating = arg"/>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  import {updateMyLanguage} from "../../../api/user.api";
  import {getAllLanguages} from "../../../api/languages.api";
  import {required} from "vuelidate/lib/validators";
  import PersonalContacts from "./PersonalContacts";

  export default {
    name: "index",
    components: {PersonalContacts, AppConfirmButtons, AppFormFeedback, AppSection},
    data() {
      return {
        form: {
          language: null
        },
        userDetails: null,
        languages: [],
        isUpdating: false
      }
    },
    validations: {
      form: {
        language: {required}
      },
    },
    methods: {
      changeLanguage() {
        this.isUpdating = true;
        updateMyLanguage(this.form).then(
          (response) => {
            this.isUpdating = false;
            this.userDetails = response.data;
            this.$i18n.locale = this.form.language.code;
            this.$store.commit("auth/setUserPersonalDetails", response.data);
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_update));
          },
          (error) => {
            this.handleApiError(error);
            this.form.language = this.userDetails.language;
            this.isUpdating = false;
          }
        )
      },
      getAllLanguages() {
        getAllLanguages(false).then(
          (response) => {
            this.languages = response.data;
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      },
      getEditableData() {
        this.form = {
          language: this.userDetails.language,
        }
      },
    },
    created() {
      this.userDetails = this.$store.getters["auth/userPersonalDetails"];
      this.getEditableData();
      this.getAllLanguages();
    }
  }
</script>

<style scoped>

</style>
